<template>
  <div class="profile padding-left-0Perc padding-right-0Perc">
      <profile-header-Bar></profile-header-Bar>
      <profile-content></profile-content>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
  </div>  
</template>

<script>
import ProfileHeaderBar from '@/components/profile/ProfileHeaderBar'
import ProfileContent from '@/components/profile/ProfileContent'
import CopyrightElement from '@/components/CopyrightElement'
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'

export default {
  data: function () {
    return {

    }
  },
  created () {
    this.trackPageLoad()
  },
  methods: {
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load Profile Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Manage_MyProfile,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'PROFILE',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    }
  },
  components: {
    'profile-header-Bar': ProfileHeaderBar,
    'profile-content': ProfileContent,
    'Copyright-Element': CopyrightElement
  },
  name: 'profile'
}
</script>

<style scoped>
.padding-left-0Perc{
  padding-left:0%;
}
.padding-right-0Perc{
  padding-right:0% !important;
}
/* Using Only for footer */
.footer{
  position: fixed;
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue